import { useState } from 'react'
import { LoginForm } from '@/components/auth/auth-login-form'
import { RegisterForm } from '@/components/auth/auth-register/auth-register-form'
import { RegisterSuccess } from '@/components/auth/auth-register/auth-register-success'
import { VerificationRequired } from '@/components/auth/auth-verification/auth-verification-required'
import { ForgotPassword } from '@/components/auth/auth-forgot-password-form'
import { GoogleAuthButton } from './auth-google'
import { Card } from '../ui/shadcn/card'

export const AuthCard = () => {
  const [type, setType] = useState<
    'login' | 'verification-required' | 'register' | 'register-success' | 'forgot-password'
  >('login')

  const [email, setEmail] = useState('')

  return (
    <Card>
      {type === 'login' ? (
        <div>
          {/* Auth UserPass */}
          <>
            <LoginForm
              email={email}
              onEmailChange={setEmail}
              onSwitchToRegister={() => setType('register')}
              onVerificationRequired={() => setType('verification-required')}
              onForgotPassword={() => setType('forgot-password')}
            />
            <div className="my-4 flex items-center">
              <div className="border-border grow border-t"></div>
              <p className="text-muted-foreground mx-4 text-sm">or</p>
              <div className="border-border grow border-t"></div>
            </div>
          </>

          {/* Auth Google */}
          <GoogleAuthButton referrerPath={window.location.pathname} flow="login" />
        </div>
      ) : type === 'register' ? (
        <RegisterForm
          email={email}
          onEmailChange={setEmail}
          onSwitchToLogin={() => setType('login')}
          onSwitchToRegisterSuccess={() => setType('register-success')}
        />
      ) : type === 'register-success' ? (
        <RegisterSuccess onSwitchToLogin={() => setType('login')} />
      ) : type === 'verification-required' ? (
        <VerificationRequired email={email} onSwitchToLogin={() => setType('login')} />
      ) : (
        <ForgotPassword
          email={email}
          onEmailChange={setEmail}
          onSwitchToLogin={() => setType('login')}
        />
      )}
    </Card>
  )
}
